import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { isTestSite, Site } from '../type/site';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  private _allowedSites: Promise<Site[]>;
  private _siteInSite: Promise<Site[]>;

  private allowedSitesList: Site[] = [];

  /** Session-scoped test-sites state — shared across all reports until logout. */
  testSiteIds: Set<string> = new Set();
  hasTestSites: boolean = false;
  includeTestSites: boolean = false;

  /** User-class site limit (BE: SiteInUserClass, delivered on login as USER.siteIdsFilter). */
  private _userClassSiteIds: Set<string>;

  httpOptions;

  get allowedSites(): Site[] {
    return this.allowedSitesList;
  }

  constructor(private http: HttpClient) {
    const currentUser = sessionStorage.getItem('TOKEN');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + currentUser
      })
    };
  }

  fetchAllowedSites(): Promise<Site[]> {
    if (!this._allowedSites) {
      return this._allowedSites = this.http.get(`${environment.systemAPI}/api/sys/sites`,
        this.httpOptions).toPromise()
        .then((response: any) => {
          this.allowedSitesList =  (response?.list || []);
          this.initTestSitesState();
          return (response?.list || []) as Site[];
        })
        .catch(error => {
          // Don't cache a failure forever (e.g. BIG-98: a call made before login has a token) -
          // clear it so the next call retries instead of replaying a stale rejection.
          this._allowedSites = undefined;
          return Promise.reject(error.message || error);
        });
    }
    return this._allowedSites;
  }

  private initTestSitesState(): void {
    this.testSiteIds = new Set();
    this.allowedSitesList.forEach(s => {
      if (isTestSite(s)) {
        this.testSiteIds.add(String(s.siteId));
      }
    });
    this.hasTestSites = this.testSiteIds.size > 0;
  }

  /**
   * Site IDs allowed by the user's class (BE: List<Short> on USER.siteIdsFilter).
   * Read from the session's USER so it always reflects the current login. Null or empty = no filter.
   */
  get userClassSiteIds(): Set<string> {
    if (!this._userClassSiteIds) {
      const currentUser: any = JSON.parse(sessionStorage.getItem('USER'));
      const list = currentUser?.siteIdsFilter;
      this._userClassSiteIds = (list && Array.isArray(list))
        ? new Set(list.map((id: number) => String(id)))
        : new Set<string>();
    }
    return this._userClassSiteIds;
  }

  /** True when the user's class limits them to a subset of sites. */
  get hasUserClassSiteFilter(): boolean {
    return this.userClassSiteIds.size > 0;
  }

  /** Keep only the sites allowed by the user's class. No filter = list returned unchanged. */
  filterSitesByUserClass(sites: Site[]): Site[] {
    if (!this.hasUserClassSiteFilter) {
      return sites;
    }
    return (sites || []).filter(site => this.userClassSiteIds.has(String(site.siteId)));
  }

  fetchSiteInSite(): Promise<Site[]> {
    //TODO:: strange duplicate behavior to be resolved in later versions
    return this.fetchAllowedSites();

    // if (!this._siteInSite) {
    //   return this._siteInSite = this.http.get(`${environment.systemAPI}${'/api/sys/sites'}`,
    //     this.httpOptions).toPromise()
    //     .then((response: any ) => {
    //       return (response?.list || []) as Site[];
    //     })
    //     .catch(error => {
    //       return Promise.reject(error.message || error);
    //     });
    // }
    // return this._siteInSite;
  }
  fetchSiteInSiteHO(): Promise<Site[]> {
    if (!this._siteInSite) {
      return this._siteInSite = this.http.get(`${environment.systemAPI}${'/api/sys/sites/ho'}`,
        this.httpOptions).toPromise()
        .then((response: any ) => {
          return (response?.list || []) as Site[];
        })
        .catch(error => {
          return Promise.reject(error.message || error);
        });
    }
    return this._siteInSite;
  }
}
